import { connect } from 'react-redux';
import Dashboard from '../../../components/dashboard/Dashboard';
import { getMasivos } from 'core/slices/masivos';
import { masivos, profile, sucursal_id } from 'core/selectors';

export default connect(
  state => ({
    masivos: masivos(state),
    profile: profile(state),
    sucursal_id: sucursal_id(state),
  }),
  { getMasivos },
)(Dashboard);
